import ReactGA from 'react-ga4';

export const initGA = () => {
  if (typeof window !== 'undefined') {
    ReactGA.initialize(import.meta.env.VITE_GA_MEASUREMENT_ID); 
  } 
};